export default "__VITE_ASSET__625d4297__"